import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DateUtilsService } from 'src/app/modules/shared/services/date-utils/date-utils.service';

@Component({
  selector: 'app-generic-historic',
  templateUrl: './generic-historic.component.html',
  styleUrls: ['./generic-historic.component.scss'],
})
export class GenericHistoricComponent {
  @Input() changes!: Array<{
    data: string;
    autor: string;
    alteracoes: Array<{
      coluna: string;
      valorAnterior: string;
      valorPosterior: string;
    }>;
  }>;

  @Input() fieldMappings!: { [key: string]: string };

  constructor(
    private modalCtrl: ModalController,
    private dateUtils: DateUtilsService,
  ) {}

  formatField(field: string): string {
    return this.fieldMappings[field] || this.humanizeField(field);
  }

  /**
   * Fallback para campos sem rótulo mapeado: transforma a chave crua
   * (camelCase/PascalCase, snake_case ou kebab-case) em texto legível,
   * com espaços e apenas a primeira letra maiúscula. Ex.: "bloqueioEm" → "Bloqueio em".
   */
  private humanizeField(field: string): string {
    if (!field) return field;
    const comEspacos = field
      .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      .replace(/[_-]+/g, ' ')
      .trim();
    const minusculo = comEspacos.toLowerCase();
    return minusculo.charAt(0).toUpperCase() + minusculo.slice(1);
  }

  formatDateToReadable(isoDate: string): string {
    return this.dateUtils.formatDateToReadable(isoDate);
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  confirm() {
    return this.modalCtrl.dismiss(null, 'confirm');
  }
}
